module.exports = __webpack_public_path__ + "img/entrepreneurship-454.eca007c6.png";